import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {IDataPartner} from "../../../types";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine} from 'recharts';
import {Typography, Checkbox} from "@material-ui/core";


interface IProps {
    partnerData: IDataPartner
}

interface Istate {
    numberCrops: IRowChart[]
    areaCrops: IRowChart[]
    otro: boolean
    superficie: boolean
}

interface IRowChart {
    name: string
    basico: number,
    avanzado: number,
    profesional: number,
    otro: number
}

class Cultivos extends React.Component<IProps, Istate> {

    state:Istate = {
        numberCrops: [] as IRowChart[],
        areaCrops: [] as IRowChart[],
        otro: false,
        superficie: false
    }

    componentDidMount() {
        this.createDataChart()
    }

    createDataChart = () => {
        if (!this.props.partnerData.hasOwnProperty("plots")) {
            setTimeout(() => this.createDataChart(), 200)
            return
        }
        if (!this.props.partnerData.hasOwnProperty("users")) {
            setTimeout(() => this.createDataChart(), 200)
            return
        }

        let users_basico = [] as string[]
        let users_avanzado = [] as string[]
        let users_profesional = [] as string[]
        let users_otro = [] as string[]

        for (let user of this.props.partnerData.users) {
            if (user.level === 1) {
                users_basico.push(user.nombre as string)
            } else if (user.level === 2) {
                users_avanzado.push(user.nombre as string)
            } else if (user.level === 3) {
                users_profesional.push(user.nombre as string)
            } else {
                users_otro.push(user.nombre as string)
            }
        }

        if (users_otro.length > 0) {
            this.setState({otro: true})
        }

        let numberCrops = {} as any
        let areaCrops = {} as any

        for (let user of users_basico) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (!numberCrops.hasOwnProperty(plot.cultivo as string)) {
                    numberCrops[plot.cultivo as string] = {
                        "basico": 1,
                        "avanzado": 0,
                        "profesional": 0,
                        "otro": 0
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": plot.superficie as number,
                        "avanzado": 0,
                        "profesional": 0,
                        "otro": 0
                    }
                } else {
                    numberCrops[plot.cultivo as string] = {
                        "basico": numberCrops[plot.cultivo as string]["basico"] + 1,
                        "avanzado": numberCrops[plot.cultivo as string]["avanzado"],
                        "profesional": numberCrops[plot.cultivo as string]["profesional"],
                        "otro": numberCrops[plot.cultivo as string]["otro"]
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": areaCrops[plot.cultivo as string]["basico"] + plot.superficie as number,
                        "avanzado": areaCrops[plot.cultivo as string]["avanzado"],
                        "profesional": areaCrops[plot.cultivo as string]["profesional"],
                        "otro": areaCrops[plot.cultivo as string]["otro"]
                    }
                }
            }
        }

        for (let user of users_avanzado) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (!numberCrops.hasOwnProperty(plot.cultivo as string)) {
                    numberCrops[plot.cultivo as string] = {
                        "basico": 0,
                        "avanzado": 1,
                        "profesional": 0,
                        "otro": 0
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": 0,
                        "avanzado": plot.superficie as number,
                        "profesional": 0,
                        "otro": 0
                    }
                } else {
                    numberCrops[plot.cultivo as string] = {
                        "basico": numberCrops[plot.cultivo as string]["basico"],
                        "avanzado": numberCrops[plot.cultivo as string]["avanzado"] + 1,
                        "profesional": numberCrops[plot.cultivo as string]["profesional"],
                        "otro": numberCrops[plot.cultivo as string]["otro"]
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": areaCrops[plot.cultivo as string]["basico"],
                        "avanzado": areaCrops[plot.cultivo as string]["avanzado"] + plot.superficie as number,
                        "profesional": areaCrops[plot.cultivo as string]["profesional"],
                        "otro": areaCrops[plot.cultivo as string]["otro"]
                    }
                }
            }
        }

        for (let user of users_profesional) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (!numberCrops.hasOwnProperty(plot.cultivo as string)) {
                    numberCrops[plot.cultivo as string] = {
                        "basico": 0,
                        "avanzado": 0,
                        "profesional": 1,
                        "otro": 0
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": 0,
                        "avanzado": 0,
                        "profesional": plot.superficie as number,
                        "otro": 0
                    }
                } else {
                    numberCrops[plot.cultivo as string] = {
                        "basico": numberCrops[plot.cultivo as string]["basico"],
                        "avanzado": numberCrops[plot.cultivo as string]["avanzado"],
                        "profesional": numberCrops[plot.cultivo as string]["profesional"] + 1,
                        "otro": numberCrops[plot.cultivo as string]["otro"]
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": areaCrops[plot.cultivo as string]["basico"],
                        "avanzado": areaCrops[plot.cultivo as string]["avanzado"],
                        "profesional": areaCrops[plot.cultivo as string]["profesional"] + plot.superficie as number,
                        "otro": areaCrops[plot.cultivo as string]["otro"]
                    }
                }
            }
        }

        for (let user of users_otro) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (!numberCrops.hasOwnProperty(plot.cultivo as string)) {
                    numberCrops[plot.cultivo as string] = {
                        "basico": 0,
                        "avanzado": 0,
                        "profesional": 0,
                        "otro": 1
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": 0,
                        "avanzado": 0,
                        "profesional": 0,
                        "otro":  plot.superficie as number
                    }
                } else {
                    numberCrops[plot.cultivo as string] = {
                        "basico": numberCrops[plot.cultivo as string]["basico"],
                        "avanzado": numberCrops[plot.cultivo as string]["avanzado"],
                        "profesional": numberCrops[plot.cultivo as string]["profesional"],
                        "otro": numberCrops[plot.cultivo as string]["otro"] + 1
                    }
                    areaCrops[plot.cultivo as string] = {
                        "basico": areaCrops[plot.cultivo as string]["basico"],
                        "avanzado": areaCrops[plot.cultivo as string]["avanzado"],
                        "profesional": areaCrops[plot.cultivo as string]["profesional"],
                        "otro": areaCrops[plot.cultivo as string]["otro"] + plot.superficie as number
                    }
                }
            }
        }

        let orderedNumberCrops = [] as IRowChart[]
        let ordered = [] as string[]
        for (let _ = 0; _ < Object.keys(numberCrops).length; _++) {

            let max = 0
            let max_crop = ""
            for (let crop of Object.keys(numberCrops)) {
                let total = numberCrops[crop]["basico"] + numberCrops[crop]["avanzado"] + numberCrops[crop]["profesional"] + numberCrops[crop]["otro"]
                if (!ordered.includes(crop) && total > max) {
                    max = total
                    max_crop = crop
                }
            }
            ordered.push(max_crop)
            orderedNumberCrops.push({
                name: max_crop.replace(/_/gi, ' '),
                basico: numberCrops[max_crop]["basico"],
                avanzado: numberCrops[max_crop]["avanzado"],
                profesional: numberCrops[max_crop]["profesional"],
                otro: numberCrops[max_crop]["otro"]
            })
        }

        let orderedAreaCrops = [] as IRowChart[]
        ordered = [] as string[]
        for (let _ = 0; _ < Object.keys(areaCrops).length; _++) {

            let max = 0
            let max_crop = ""
            for (let crop of Object.keys(areaCrops)) {
                let total = areaCrops[crop]["basico"] + areaCrops[crop]["avanzado"] + areaCrops[crop]["profesional"] + areaCrops[crop]["otro"]
                if (!ordered.includes(crop) && total > max) {
                    max = total
                    max_crop = crop
                }
            }
            ordered.push(max_crop)
            orderedAreaCrops.push({
                name: max_crop.replace(/_/gi, ' '),
                basico: Math.round(areaCrops[max_crop]["basico"]/1000)/10,
                avanzado: Math.round(areaCrops[max_crop]["avanzado"]/1000)/10,
                profesional: Math.round(areaCrops[max_crop]["profesional"]/1000)/10,
                otro: Math.round(areaCrops[max_crop]["otro"]/1000)/10
            })
        }
        this.setState({
            numberCrops: orderedNumberCrops,
            areaCrops: orderedAreaCrops
        })
    }


    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    width: '100%',
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 20
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        height: 60,
                        width: '100%',
                        marginTop: 20
                    }}
                >
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginLeft: 40
                        }}
                    >
                        Cultivos
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: 300,
                            height: "100%",
                            marginRight: 'calc(10%)'
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                        >
                            <Checkbox
                                style={{color: "black"}}
                                checked={!this.state.superficie}
                                onChange={() => this.setState({superficie: false})}
                            />

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14
                                }}
                            >
                                Parcelas
                            </Typography>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginLeft: 20
                            }}
                        >
                            <Checkbox
                                style={{color: "black"}}
                                checked={this.state.superficie}
                                onChange={() => this.setState({superficie: true})}
                            />

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: 14
                                }}
                            >
                                Superficie (Ha)
                            </Typography>
                        </div>

                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 'calc(100% - 40px)',
                        height: 'calc(100% - 100px)',
                        overflowY: "auto"
                    }}
                >
                    <div
                        style={{
                            width: '95%',
                            height: this.state.numberCrops.length*60
                        }}
                    >
                        <ResponsiveContainer
                            width="100%"
                            height="100%"
                        >
                            <BarChart
                                margin={{
                                    top: 0,
                                    right: 0,
                                    left: 30,
                                    bottom: 30,
                                }}
                                data={this.state.superficie? this.state.areaCrops : this.state.numberCrops}
                                barCategoryGap={5}
                                barGap={0}
                                layout="vertical"
                            >
                                <Tooltip wrapperStyle={{fontSize: 14, fontFamily: "Poppins"}}/>
                                <CartesianGrid strokeDasharray={"3 3"} horizontal={true} vertical={true}/>
                                <YAxis dataKey="name" type="category" style={{fontSize: 14, fontFamily: "Poppins"}}/>
                                <XAxis type="number" />
                                <Bar dataKey="basico" fill="#FF7777" stackId="a" />
                                <Bar dataKey="avanzado" fill="#694BDB" stackId="a" />
                                <Bar dataKey="profesional" fill="#2BEBC8" stackId="a" />
                                {this.state.otro &&
                                    <Bar dataKey="otro" fill="#f6d947" stackId="a" />
                                }
                            </BarChart>
                        </ResponsiveContainer>
                    </div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Cultivos);
